module.exports = __webpack_public_path__ + "img/backroll.92426b7b.png";